import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

export default function Footer() {
  const { t } = useTranslation('common')

  return (
    <footer className="bg-[#071a50] py-14 text-white">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
        <div className="grid gap-10 border-b border-white/15 pb-12 md:grid-cols-[1.45fr_0.8fr_0.8fr]">
          <div className="max-w-xl">
            <Link to="/" className="inline-flex items-center gap-3">
              <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-white">
                <img src="/brand/jeridschool-symbol.png" alt="" className="h-10 w-10 object-contain" />
              </span>
              <span className="text-2xl font-black tracking-[-0.04em]">
                <span className="text-[#69a9ff]">Jerid</span>School
              </span>
            </Link>
            <p className="mt-5 max-w-lg text-sm leading-7 text-blue-100/80">
              {t('footer.description')}
            </p>
            <div className="mt-6 flex gap-3 text-sm font-bold">
              <a className="rounded-full border border-white/20 px-4 py-2 transition hover:bg-white hover:text-[#071a50]" href="https://www.facebook.com/profile.php?id=61561679156925" target="_blank" rel="noopener noreferrer">Facebook</a>
              <a className="rounded-full border border-white/20 px-4 py-2 transition hover:bg-white hover:text-[#071a50]" href="https://www.linkedin.com/company/105981853/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
            </div>
          </div>

          <div>
            <h3 className="font-black text-[#f7c74f]">{t('footer.quickLinks.title')}</h3>
            <ul className="mt-5 space-y-3 text-sm font-semibold text-blue-100/80">
              <li><Link to="/" className="transition hover:text-white">{t('footer.quickLinks.home')}</Link></li>
              <li><Link to="/features" className="transition hover:text-white">{t('footer.quickLinks.features')}</Link></li>
              <li><Link to="/demo" className="transition hover:text-white">{t('footer.quickLinks.bookDemo')}</Link></li>
              <li><Link to="/join" className="transition hover:text-white">{t('footer.quickLinks.joinNow')}</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-black text-[#f7c74f]">{t('footer.contactUs.title')}</h3>
            <ul className="mt-5 space-y-3 text-sm font-semibold text-blue-100/80">
              <li>{t('footer.contactUs.location')}</li>
              <li><a className="transition hover:text-white" href="mailto:support@jeridschool.com">{t('footer.contactUs.email')}</a></li>
              <li><a className="transition hover:text-white" href="https://www.jeridschool.com">{t('footer.contactUs.website')}</a></li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col gap-4 pt-7 text-sm text-blue-100/60 sm:flex-row sm:items-center sm:justify-between">
          <p>{t('footer.copyright', { year: new Date().getFullYear() })}</p>
          <div className="flex gap-5">
            <Link to="/privacy-policy" className="transition hover:text-white">Privacy</Link>
            <Link to="/contact" className="transition hover:text-white">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
